import { AnchoringLetGoData } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const ANCHORING_LET_GO_DATA_TAG = 'AnchoringLetGoData';
export default class AnchoringLetGoParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.ANCHORING_LET_GO, FIXED_PROTOCOL_CONTENT_TYPE_IDS.ANCHORING_LET_GO, ANCHORING_LET_GO_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            anchor: 'anchor',
            freeText: 'freeText',
        };
    }
    createData(props) {
        return new AnchoringLetGoData(props.anchor, props.freeText);
    }
}
//# sourceMappingURL=AnchoringLetGoParser.js.map